import { render, staticRenderFns } from "./Metrics.html?vue&type=template&id=2ea2769c&scoped=true&"
import script from "./Metrics.js?vue&type=script&lang=js&"
export * from "./Metrics.js?vue&type=script&lang=js&"
import style0 from "./Metrics.scss?vue&type=style&index=0&id=2ea2769c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea2769c",
  null
  
)

export default component.exports